import PropTypes from 'prop-types';

export const VIDEO_CARD_THUMBNAIL_SIZE_PX = 500;

export const BUTTONS_DEFAULT_TITLE = {
  PRIMARY: 'Pricing & Reviews',
  SECONDARY: 'See Rankings',
};

export const LinkDataPropType = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
  nofollow: PropTypes.bool,
  blank: PropTypes.bool,
});
